import React, { useEffect } from 'react';

function TawkTo() {
  useEffect(() => {
    var Tawk_API = Tawk_API || {};
    const Tawk_LoadStart = new Date();
    (function () {
      const s1 = document.createElement('script');
      const s0 = document.getElementsByTagName('script')[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/622eb9911ffac05b1d7e68fc/1jht0hegv';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
    }());
    return () => {};
  }, []);
  return <></>;
}

export default TawkTo;
